import type { CartItem, StorefrontProduct } from "../types/storefront";
import { fromMinorUnits, toMinorUnits } from "./currency";

export function getCartStorageKey(tenantSlug: string, branchId: string) {
  return `elmor-storefront-cart:${tenantSlug}:${branchId}`;
}

export function clampProductQuantity(product: StorefrontProduct, requested: number) {
  if (requested <= 0) return 0;
  const minimum = product.minimumOrderQuantity ?? 1;
  const maximum = Math.min(
    product.maximumOrderQuantity ?? Infinity,
    product.availableQuantity ?? Infinity
  );
  return Math.max(minimum, Math.min(Math.floor(requested), maximum));
}

export function calculateCartSubtotal(items: CartItem[]) {
  return fromMinorUnits(
    items.reduce(
      (total, item) =>
        total + toMinorUnits(item.product.websitePrice ?? item.product.price) * item.quantity,
      0
    )
  );
}
